import React, { useEffect, useMemo } from 'react';

import { useGetLists } from '@vlabs/api/artemy/client';
import { ControllableValueSelect } from '@vlabs/monokit/shared/ui/value-select';
import validate from '@vlabs/shared/validators';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

function SearchByFaces(): React.JSX.Element {
  const { t } = useTranslation();
  const {
    control, setValue, formState: { errors },
  } = useFormContext();
  const { data, isLoading } = useGetLists({ page_size: 100 });
  const selectedListId = useWatch({ control, name: 'candidates.list_id' });
  const listOptions = useMemo(() => (data?.lists ?? []).map(({ list_id, user_data }) => ({
    label: user_data || list_id,
    value: list_id,
  })), [data?.lists]);

  useEffect(() => {
    if (!selectedListId) {
      setValue('label', '', { shouldValidate: true });
      return;
    }

    const selectedList = listOptions.find(({ value }) => value === selectedListId);
    if (!selectedList) return;

    setValue('label', selectedList.label, { shouldValidate: true });
  }, [listOptions, selectedListId, setValue]);

  return (
    <ControllableValueSelect
      control={control}
      data-testid="matchPolicy.list"
      errors={errors}
      isClearable
      isLoading={isLoading}
      label={t('list')}
      name="candidates.list_id"
      options={listOptions}
      rules={{ required: validate.required() }}
    />
  );
}

export { SearchByFaces };
